module.exports = __webpack_public_path__ + "static/littlebutloudhamper-a19ad6035a56968238fd2c20aa5afe57.jpeg";